import { ExclamationCircleIcon } from "@heroicons/react/24/solid";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function RoundEndedBanner() {
  return /*#__PURE__*/_jsx("div", {
    children: /*#__PURE__*/_jsx("div", {
      className: "bg-pink-100",
      children: /*#__PURE__*/_jsx("div", {
        className: "max-w-full py-3 px-3 sm:px-6 lg:px-8 z-0",
        children: /*#__PURE__*/_jsxs("div", {
          className: "flex flex-row flex-wrap items-center justify-center",
          children: [/*#__PURE__*/_jsx(ExclamationCircleIcon, {
            "aria-label": "Exclamation icon",
            className: "fill-red-500 stroke-red-200 h-7 w-7 relative text-white items-center rounded-full"
          }), /*#__PURE__*/_jsx("span", {
            className: "ml-3 font-medium text-sm",
            children: "This round has ended. Thank you for your support!"
          })]
        })
      })
    })
  });
}